import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Crosshair } from 'lucide-react';
import Footer from '../components/Footer';
import { CONTACT_INFO, IMAGES } from '../mock';

const InfoCard = ({ icon: Icon, label, children, href }) => {
  const inner = (
    <div className="group h-full p-8 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-[#e11d2a]/40 hover:bg-white/[0.05] transition-all duration-500 hover:-translate-y-1.5 text-center">
      <span className="mx-auto w-14 h-14 rounded-xl bg-[#e11d2a]/10 border border-[#e11d2a]/20 flex items-center justify-center mb-6 group-hover:bg-[#e11d2a]/20 transition-colors">
        <Icon className="w-6 h-6 text-[#e11d2a]" strokeWidth={1.6} />
      </span>
      <p className="text-xs uppercase tracking-widest text-white/40 mb-2">{label}</p>
      <div className="text-white/85 text-sm leading-relaxed">{children}</div>
    </div>
  );
  return href ? (
    <a href={href} className="block h-full">{inner}</a>
  ) : (
    inner
  );
};

const Contact = () => {
  return (
    <div className="bg-[#060608] text-white min-h-screen">
      {/* top bar */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#060608]/90 backdrop-blur-md border-b border-white/5 py-3">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex items-center justify-center w-9 h-9 rounded-full border border-[#e11d2a]/70">
              <Crosshair className="w-5 h-5 text-[#e11d2a]" strokeWidth={1.5} />
            </span>
            <span className="font-display leading-none">
              <span className="block text-[#e11d2a] tracking-[0.22em] text-[15px]">PRECISION</span>
              <span className="block text-white/90 tracking-[0.34em] text-[11px] font-light">ANALYTICS</span>
            </span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </header>

      {/* hero */}
      <section className="relative pt-40 pb-16">
        <div className="absolute inset-0 overflow-hidden">
          <img src={IMAGES.earthNetwork} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#060608]/70 via-[#060608]/85 to-[#060608]" />
          <div className="absolute inset-0 grid-overlay opacity-30" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <span className="text-[11px] tracking-[0.3em] uppercase text-[#e11d2a] animate-fade-up">Get in Touch</span>
          <h1 className="font-display font-light text-4xl md:text-6xl mt-5 animate-fade-up" style={{ animationDelay: '80ms' }}>Let’s measure what matters</h1>
          <p className="mt-5 text-white/55 text-lg max-w-xl mx-auto animate-fade-up" style={{ animationDelay: '160ms' }}>
            Reach out to our team using the details below and we’ll get back to you promptly.
          </p>
        </div>
      </section>

      {/* contact information */}
      <section className="relative pb-28">
        <div className="max-w-md mx-auto px-6">
          <InfoCard icon={Mail} label="Email" href={`mailto:${CONTACT_INFO.email}`}>
            {CONTACT_INFO.email}
          </InfoCard>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
